<footer class="main-footer">
  <div class="container footer-content">
    <!-- Column 1: Logo and Message -->
    <div class="footer-column">
      <img src="assets/images/ctc_network_logo_white.png" alt="CTC Network Logo" class="footer-logo">
      <p class="inspiring-message">{{ 'footer.INSPIRING_MESSAGE' | translate }}</p>
    </div>


    <!-- Column 2: Follow Us -->
    <div class="footer-column">
      <h4 class="footer-title">{{ 'footer.FOLLOW_US' | translate }}</h4>
      <div class="social-icons">
        <a href="https://www.linkedin.com/company/ctc-network-ca/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
          <svg class="social-icon" viewBox="0 0 24 24"><path d="M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19M18.5,18.5V13.2A3.26,3.26 0 0,0 15.24,9.94C14.39,9.94 13.4,10.43 13,11.1V10.28H10.13V18.5H13V13.57C13,12.8 13.54,12.17 14.31,12.17A1.4,1.4 0 0,1 15.71,13.57V18.5H18.5M6.88,8.56A1.68,1.68 0 0,0 8.56,6.88C8.56,6 7.81,5.34 6.88,5.34A1.69,1.69 0 0,0 5.19,6.88C5.19,7.81 5.94,8.56 6.88,8.56M8.27,18.5V10.28H5.5V18.5H8.27Z"/></svg>
        </a>
      </div>
    </div>
  </div>

  <div class="footer-bottom">
    <div class="container">
      <p>{{ 'footer.COPYRIGHT' | translate: {year: copyrightYears} }}</p>
      <div class="footer-links">
        <a routerLink="/privacy-policy"  target="_blank"  class="footer-link">{{ 'footer.PRIVACY_POLICY' | translate }}</a>
        <span class="separator">|</span>
        <a routerLink="/terms-conditions" target="_blank" class="footer-link">{{ 'footer.TERMS_CONDITIONS' | translate }}</a>

      </div>
    </div>
  </div>
</footer>